import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ProyectoService } from '../services/proyecto.service';
import { GlobalModalService } from '../shared/global-modal/global-modal.service';
import { LoggerService } from '../services/logger.service';

@Component({
  selector: 'app-task-execution-manager',
  templateUrl: './task-execution-manager.component.html',
  styleUrls: ['./task-execution-manager.component.scss']
})
export class TaskExecutionManagerComponent implements OnInit {
  project: any;
  
  unplannedExecutions: any[] = [];
  transversalExecutions: any[] = [];
  trashExecutions: any[] = [];
  
  plannedGroups: { 
    reqName: string, 
    tasks: { task: any, executions: any[], dropId: string }[] 
  }[] = [];

  connectedDropLists: string[] = ['unplannedList', 'transversalList', 'trashList'];

  constructor(
    private router: Router,
    private proyectoService: ProyectoService,
    private modalService: GlobalModalService,
    private logger: LoggerService
  ) {}

  ngOnInit(): void {
    const storedProject = sessionStorage.getItem('selectedProject');
    if (!storedProject) {
      this.router.navigate(['/app/home']);
      return;
    }
    
    this.project = JSON.parse(storedProject);
    this.buildBoard();
  }

  buildBoard() {
    this.unplannedExecutions = [];
    this.transversalExecutions = [];
    this.plannedGroups = [];
    this.trashExecutions = [];
    this.connectedDropLists = ['unplannedList', 'transversalList', 'trashList'];

    const allExecutions = this.project.taskexecutions || [];
    const matchedExecutionIds = new Set<string>();

    if (this.project.estimation && this.project.estimation.requirements) {
      this.project.estimation.requirements.forEach((req: any) => {
        const group = { reqName: req.description, tasks: [] as any[] };

        (req.tasks || []).forEach((task: any) => {
          const dropId = `taskDrop_${task.id}`;
          this.connectedDropLists.push(dropId);

          const taskExecs = allExecutions.filter((ex: any) => ex.taskid === task.id);
          taskExecs.forEach((ex: any) => matchedExecutionIds.add(ex.id));

          group.tasks.push({
            task: task,
            executions: taskExecs,
            dropId: dropId
          });
        });

        if (group.tasks.length > 0) {
          this.plannedGroups.push(group);
        }
      });
    }

    const orphanExecutions = allExecutions.filter((ex: any) => !matchedExecutionIds.has(ex.id));
    // FIX: Tipado explícito de 'ex' como 'any' para evitar error TS7006
    this.transversalExecutions = orphanExecutions.filter((ex: any) => ex.istransversal === true);
    this.unplannedExecutions = orphanExecutions.filter((ex: any) => !ex.istransversal);
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  saveChanges() {
    // FIX: Tipado explícito en map y forEach
    const deletions = this.trashExecutions.map((ex: any) => ex.id);
    const updates: any[] = [];

    this.plannedGroups.forEach(group => {
      group.tasks.forEach(taskContainer => {
        taskContainer.executions.forEach((ex: any) => {
          if (ex.taskid !== taskContainer.task.id || ex.istransversal !== false) {
            updates.push({ id: ex.id, taskid: taskContainer.task.id, istransversal: false });
            ex.taskid = taskContainer.task.id; 
            ex.istransversal = false;
          }
        });
      });
    });

    this.transversalExecutions.forEach((ex: any) => {
      if (ex.taskid !== null || ex.istransversal !== true) {
        updates.push({ id: ex.id, taskid: null, istransversal: true });
        ex.taskid = null;
        ex.istransversal = true;
      }
    });

    this.unplannedExecutions.forEach((ex: any) => {
      if (ex.taskid !== null || ex.istransversal !== false) {
        updates.push({ id: ex.id, taskid: null, istransversal: false });
        ex.taskid = null;
        ex.istransversal = false;
      }
    });

    if (deletions.length === 0 && updates.length === 0) {
      this.modalService.showSuccess('Aviso', 'No hay cambios que guardar.');
      return;
    }

    this.proyectoService.bulkUpdateExecutions(this.project.id, { updates, deletions }).subscribe({
      next: () => {
        this.modalService.showSuccess('Éxito', 'Las ejecuciones se han actualizado correctamente.');
        
        this.project.taskexecutions = [
          ...this.unplannedExecutions,
          ...this.transversalExecutions,
          ...this.plannedGroups.flatMap(g => g.tasks.flatMap(t => t.executions))
        ];
        sessionStorage.setItem('selectedProject', JSON.stringify(this.project));

        this.trashExecutions = [];
        this.buildBoard();
      },
      error: (err: any) => {
        this.logger.error('Error guardando ejecuciones masivas:', err);
      }
    });
  }

  goBack() {
    this.router.navigate(['/app/proyecto']);
  }
}